import React from 'react'
import { withRouter } from 'react-router-dom'
import base64url from 'base64url'
import { Container, Header } from '../../components_renew/Layout'
import btn_recharge from '../../assets/img/tutorial-banner-btn.png'

@withRouter
class Frame extends React.PureComponent {
  constructor (props) {
    super(props)
    const { search: SearchParams } = props.location
    const urlParams = new URLSearchParams(SearchParams)
    this.withHeader = urlParams.get('withHeader')
    const btnType = urlParams.get('btn')
    switch (btnType) {
      case 'recharge':
        this.btn = btn_recharge
        break
      default:
    }
  }

  componentDidMount () {
    let { title } = this.props.match.params
    if (title) {
      document.title = title
    }
  }

  render () {
    const { src, title } = this.props.match.params
    return <Container>
      {this.withHeader ? <Header>{title}</Header> : null}
      <iframe style={{
        flex: '1 1 auto',
        border: 'none',
        width: '100%',
        height: '100%',
        background: '#fff'
      }} title={'frame'}
              src={base64url.decode(src)}
        // src={'http://www.baidu.com'}
      />
      {
        this.btn
          ? <div className={'fixed bottom-8 w-full'} onClick={this.onBtnClick}>
            <img className={'m-auto block'} src={this.btn} alt=""/>
          </div>
          : null
      }
    </Container>
  }

}

export default Frame
